export function genTooltipText(params, opts) {
    const nextParams = Array.isArray(params) ? params : [params];
    return nextParams
        .map((item, index) => {
        return `<p style="margin:0;">
      <span style="display:inline-block;margin-right:5px;border-radius:6px;width:6px;height:6px;background-color:${item.color};vertical-align: middle;"></span>
      <span style="vertical-align: middle;">${item.seriesName} : ${item.data.value}${item.data.isRate ? '%' : ''}</span>
      </p>`;
    })
        .join('');
}
export function genToolTip(params, opts = {}) {
    const name = Array.isArray(params) ? params[0].name : params.name;
    let seriesName = '';
    if (opts.map) {
        seriesName = opts.map[name] || '';
    }
    else {
        seriesName = seriesName || '';
    }
    return `<div style="width:100%;height:100%;font-size:12px;">
        <p style="margin:0">${seriesName}</p>
          ${genTooltipText(params, opts)}
        </div>`;
}
export function genToolTipCfg(cfg) {
    return Object.assign({ backgroundColor: '#fff', textStyle: {
            color: '#000',
        }, extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.15);' }, cfg);
}
export function formateXaxis(dates) {
    if (!dates || !dates.length) {
        return [];
    }
    const time = [];
    const map = {};
    dates.forEach((item, index) => {
        time.push(item.replace(/\d{4}\//, ''));
        map[time[index].toString()] = item;
    });
    return {
        time,
        map,
    };
}
;
